var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-calendar',{ref:"calendar",attrs:{"filterObj":_vm.filters,"api":_vm.apiCall,"setEventsandUsers":_vm.setEntitySchedules,"calendarOption":_vm.calendarOptions,"classes":'fullcalendar-header-style-lg',"onEventClick":_vm.handleEventClick,"filters":{ setCustomButtons: true }}})
}
var staticRenderFns = []

export { render, staticRenderFns }